<template>
	<div class="menu_box">
		<div
			v-for="(item, index) in moreMenuBoxList"
			:key="index"
			class="menu_item"
			@click="onMenuClick(item.group, item.path)"
		>
			<div class="menu_item_img">
				<component :is="item.icon" :width="34" :height="34" />
			</div>
			<span class="menu_title">{{ item.title }}</span>
		</div>
	</div>
</template>
<script setup lang="ts">
// core
import { computed } from 'vue';
import { useRouter } from 'vue-router';

// api
import { useGetCheckAuthApi } from '@/api/auth';
// constant
import { moreMenuBoxList } from '@/constants/menu';
import {
	ALREADY_ALL_SUBSCRIPTION,
	CANCEL,
	CONFIRM_LOGIN,
	LOGIN_REQUIRED_PAGE,
	SUBSCRIPTION_RETRY,
} from '@/constants/title';
import { useLoginPopupStore } from '@/stores/LoginPopup';
// store
import { useTokenStore } from '@/stores/token';
// util
import { openMenuModal } from '@/utils/function/modalMenu';

const router = useRouter();
const tokenStore = useTokenStore();
const loginPopupStore = useLoginPopupStore();
const emit = defineEmits(['close']);

const { data: getCheckAuthData, refetch: refetchGetCheckAuth } = useGetCheckAuthApi(
	computed(() => ({
		num: 'ALL',
		student: false,
		enable: false,
	}))
);

const onMovetoAuth = () => {
	router.push('/auth/login');
};
const onMenuClick = async (group: string, path: string) => {
	if (group === 'interest' || group === 'payment') {
		if (!tokenStore.isLogin) {
			loginPopupStore.openPopup({
				icon: 'alert',
				content: LOGIN_REQUIRED_PAGE,
				confirm: onMovetoAuth,
				confirmText: CONFIRM_LOGIN,
				cancelText: CANCEL,
			});
			return;
		}

		if (group === 'interest') {
			openMenuModal({ menu: 'Interest' });
			return;
		}
	}

	if (group === 'payment') {
		await refetchGetCheckAuth();
		if (!tokenStore.isLogin) {
			loginPopupStore.openPopup({
				icon: 'alert',
				content: LOGIN_REQUIRED_PAGE,
				confirm: onMovetoAuth,
				confirmText: CONFIRM_LOGIN,
				cancelText: CANCEL,
			});
			return;
		} else if (getCheckAuthData?.value?.success) {
			loginPopupStore.openPopup({
				icon: 'alert',
				content: ALREADY_ALL_SUBSCRIPTION,
				subtext: SUBSCRIPTION_RETRY,
				confirmText: CANCEL,
				noCancelBtn: true,
			});
			return;
		}
	}
	router.push(path);
	emit('close');
};
</script>

<style lang="scss" scoped>
.menu_box {
	display: grid;
	grid-template-columns: repeat(4, 1fr);
	gap: 1rem;
	.menu_item {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		gap: 0.4rem;
		height: 8rem;
		background-color: var(--color-bg-mid);
		border-radius: 0.8rem;
		cursor: pointer;

		&:nth-child(2) {
			position: relative;

			&::after {
				content: 'Event';
				position: absolute;
				top: 4px;
				left: -8px;
				padding: 0 var(--space-x-small);

				border-radius: var(--border-radius-xx-small);
				rotate: -20deg;

				font-size: var(--font-s-small);

				background-color: var(--color-primary);
				z-index: 1;
			}
		}
		&_img {
			display: flex;
			justify-content: center;
			align-items: center;
			max-width: 3.4rem;
			height: 3.4rem;
			// object-fit: contain;
			// @media screen and (max-width: 360px) {
			// 	width: 4rem;
			// 	height: 4rem;
			// }
			img {
				width: 100%;
				height: 100%;
			}
		}
		.menu_title {
			font-size: var(--font-s-small);
			font-weight: var(--font-w-semi-bold);
			line-height: normal;
		}
	}
}
</style>
